import { Role } from '../types/organisation'

export const getRoleText = (role: Role): string => {
  switch (role) {
    case Role.SuperAdmin:
      return 'Super administrator'
    case Role.SubSuperAdmin:
      return 'Sub super administrator'
    case Role.OrganisationAdmin:
      return 'Administrator'
    case Role.OrganisationUser:
      return 'Front desk user'
    case Role.OrganisationRedeemer:
      return 'Redeemer'
    case Role.Dispatch:
      return 'Dispatch'
    default:
      return 'No user role found'
  }
}

const accessMap = new Map<Role, number>([
  [Role.SuperAdmin, 6],
  [Role.SubSuperAdmin, 5],
  [Role.OrganisationAdmin, 4],
  [Role.OrganisationUser, 3],
  [Role.OrganisationRedeemer, 2],
  [Role.Dispatch, 1],
])

// Roles build on one another, so anyone with a higher level role also has all the roles below
export const hasRole = (
  user: Role | undefined,
  requiredRole: Role,
): boolean => {
  if (!user) return false
  const userLevel = accessMap.get(user) || false
  const requiredLevel = accessMap.get(requiredRole) || false
  if (userLevel && requiredLevel && userLevel >= requiredLevel) return true
  return false
}
